import React from 'react'
import HomePage from '../Home'

export default HomePage
